import { Component, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { USER } from 'src/app/core/user.service';
import { UserViewModel } from 'src/view-models/user-view-model';

@Component({
  selector: 'fl-duty-status-button',
  templateUrl: './duty-status-button.component.html',
  styleUrls: ['./duty-status-button.component.scss'],
})
export class DutyStatusButtonComponent {
  public viewModel$: Observable<{
    onDuty: boolean;
    url: string;
    actionText: string;
    statusText: string;
  }>;

  constructor(@Inject(USER) private _user: UserViewModel) {
    this.viewModel$ = this._user.isOnDuty$.pipe(
      map((onDuty) =>
        onDuty
          ? {
              onDuty: true,
              url: '/duty-logs/duty-off',
              actionText: 'Duty Off',
              statusText: 'On Duty',
            }
          : {
              onDuty: false,
              url: '/duty-logs/duty-on',
              actionText: 'Duty On',
              statusText: 'Off Duty',
            },
      ),
    );
  }
}
